export const LINK_TO_RESUME =
    "https://app.enhancv.com/r/3f0a895d/oba-seward-evans?utm_source=link&utm_medium=growth&utm_campaign=resume-share";

export const PATHS = {
    home: "/",
    resume: "/resume",
};

export const ICON_SIZE = {
    tiny: "0.8rem",
    small: "1rem",
    medium: "1.25rem",
    large: "1.8rem",
};
